module.exports = __webpack_public_path__ + "static/media/health-management-2023-2.acc1d203.webp";